export default "__VITE_ASSET__20beb10f__"